import CommonTable from "../../../../../components/table/table";
import { useCommonFetch } from "../../../../../../hooks/useCommonFetch";
import { useState } from "react";
import {
  getPurchaseHistoryList,
} from "../../../../../../services/workspace/inventory.service";
import { useNavigate, useParams } from "react-router-dom";


const AssignedItemsHistoryCard = ({filters}) => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [isSubCategoryModalOpen, setIsSubCategoryModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    handlePageChange,
  } = useCommonFetch(getPurchaseHistoryList, {
    id: id,
    dataPath: "stock.data",
    totalPath: "stock.meta.total",
    errorMessage: "Failed to fetch category data!",
    debounceDelay: 500,
    customParams: {
      with: "purchaseOrder",
    },


    dataTransformer: (data) => {
      if (Array.isArray(data)) {
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item?.id,
            className: "",
            sticky: false,
            variant: "text",
          },
          issued_date: {
            data: item?.purchaseOrder?.created_at,
            className: "",
            sticky: false,
            variant: "date-time",
          },
          order_reference: {
            data: item?.purchaseOrder?.code,
            className: "",
            sticky: false,
            variant: "name",
          },
          quantity: {
            data: item?.quantity || "-",
            className: "",
            sticky: false,
            variant: "text",
          },
          unit_price: {
            data: item?.unit_price,
            className: "",
            sticky: false,
            variant: "text",
          },

          amount: {
            data: item?.purchaseOrder?.total_amount,
            className: "",
            sticky: false,
            variant: "text",
          },
        }));

        const actionButton = {
         
        };

        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  const TableHeaderData = [
    {
      label: "Order Reference",
      key: "order_reference",
    },
    {
      label: "Issued Date",
      key: "issued_date",
    },
    {
      label: "Quantity",
      key: "quantity",
    },
    {
      label: "Unit Price",
      key: "unit_price",
    },
     {
      label: "Amount",
      key: "amount",
    },
  ];

  return (
    <div className={"flex flex-col gap-2"}>
      <CommonTable
        search={search}
        TableHeaderData={TableHeaderData}
        tabledata={tableData.data}
        currentPage={currentPage}
        totalData={totalData}
        setCurrentPage={handlePageChange}
        loading={loading}
        action={tableData.action}
      />
    </div>
  );
};
export default AssignedItemsHistoryCard;
